var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contactUs"},[_c('h1',[_vm._v("联系我们")]),_c('p',[_vm._v("公司名称：北京爱启航网络科技有限公司")]),_c('p',[_vm._v("地址： 北京市海淀区北三环西路99号院西海国际大厦3号楼1217")]),_c('p',[_vm._v("电话： 400-856-9099")])])
}]

export { render, staticRenderFns }